(function () {
  'use strict';

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle(el);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function getHeaderCartTarget() {
    var wrappers = document.querySelectorAll('[data-cart-mini-toggle]');
    var fallback = null;

    for (var i = 0; i < wrappers.length; i += 1) {
      if (!fallback) fallback = wrappers[i];
      if (isVisible(wrappers[i])) {
        return wrappers[i].querySelector('svg') || wrappers[i];
      }
    }

    return fallback ? (fallback.querySelector('svg') || fallback) : null;
  }

  function createFlyIcon() {
    var icon = document.createElement('div');
    icon.setAttribute('aria-hidden', 'true');
    icon.className = 'cp-fly-to-cart-icon';

    // All important visual properties are inline so existing theme CSS cannot hide or resize it.
    icon.style.position = 'fixed';
    icon.style.left = '0';
    icon.style.top = '0';
    icon.style.width = '42px';
    icon.style.height = '42px';
    icon.style.display = 'flex';
    icon.style.alignItems = 'center';
    icon.style.justifyContent = 'center';
    icon.style.borderRadius = '999px';
    icon.style.background = '#ffffff';
    icon.style.color = '#111111';
    icon.style.boxShadow = '0 7px 24px rgba(0,0,0,.22)';
    icon.style.pointerEvents = 'none';
    icon.style.zIndex = '2147483647';
    icon.style.opacity = '1';
    icon.style.transformOrigin = '50% 50%';
    icon.style.willChange = 'transform, opacity';

    icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:block;width:22px;height:22px;min-width:22px;min-height:22px;overflow:visible;"><path d="M16 10a4 4 0 0 1-8 0"></path><path d="M3.103 6.034h17.794"></path><path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"></path></svg>';

    return icon;
  }

  function pulseHeaderCart(target) {
    if (!target || typeof target.animate !== 'function') return;
    try {
      target.animate([
        { transform: 'scale(1)' },
        { transform: 'scale(1.18)', offset: 0.45 },
        { transform: 'scale(.96)', offset: 0.75 },
        { transform: 'scale(1)' }
      ], {
        duration: 460,
        easing: 'cubic-bezier(.16,.84,.24,1)'
      });
    } catch (e) {
      // Never let animation errors affect cart or modal functionality.
    }
  }

  function cleanup(icon, target) {
    if (icon && icon.parentNode) icon.parentNode.removeChild(icon);
    pulseHeaderCart(target);
  }

  window.CPFlyToCart = function (sourceEl) {
    try {
      var target = getHeaderCartTarget();
      if (!target) return;

      var source = sourceEl && sourceEl.getBoundingClientRect ? sourceEl : document.activeElement;
      if (!source || !source.getBoundingClientRect) return;

      var start = source.getBoundingClientRect();
      var end = target.getBoundingClientRect();
      if (!start.width || !start.height || !end.width || !end.height) return;

      var iconSize = 42;
      var startX = start.left + (start.width / 2);
      var startY = start.top + (start.height / 2);
      var endX = end.left + (end.width / 2);
      var endY = end.top + (end.height / 2);
      var dx = endX - startX;
      var dy = endY - startY;
      var arc = Math.max(65, Math.min(155, Math.abs(dx) * 0.13 + Math.abs(dy) * 0.09));
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var duration = reduced ? 460 : 1050;

      var icon = createFlyIcon();
      icon.style.left = (startX - iconSize / 2) + 'px';
      icon.style.top = (startY - iconSize / 2) + 'px';
      document.body.appendChild(icon);

      if (typeof icon.animate === 'function') {
        var keyframes;

        if (reduced) {
          keyframes = [
            { transform: 'translate3d(0,0,0) scale(.9)', opacity: 1 },
            { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(.35)', opacity: .15 }
          ];
        } else {
          keyframes = [
            { transform: 'translate3d(0,0,0) scale(.72)', opacity: 0 },
            { transform: 'translate3d(0,0,0) scale(1)', opacity: 1, offset: .10 },
            { transform: 'translate3d(' + (dx * .30) + 'px,' + ((dy * .22) - (arc * .72)) + 'px,0) scale(.98)', opacity: 1, offset: .34 },
            { transform: 'translate3d(' + (dx * .66) + 'px,' + ((dy * .61) - arc) + 'px,0) scale(.82)', opacity: 1, offset: .70 },
            { transform: 'translate3d(' + (dx * .90) + 'px,' + ((dy * .89) - (arc * .30)) + 'px,0) scale(.52)', opacity: .92, offset: .90 },
            { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(.28)', opacity: .10 }
          ];
        }

        var animation = icon.animate(keyframes, {
          duration: duration,
          easing: 'cubic-bezier(.16,.84,.24,1)',
          fill: 'forwards'
        });
        animation.onfinish = function () { cleanup(icon, target); };
        animation.oncancel = function () { cleanup(icon, target); };
      } else {
        icon.style.transition = 'transform ' + duration + 'ms cubic-bezier(.16,.84,.24,1), opacity ' + duration + 'ms ease';
        window.requestAnimationFrame(function () {
          icon.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(.28)';
          icon.style.opacity = '.1';
        });
        window.setTimeout(function () { cleanup(icon, target); }, duration + 30);
      }
    } catch (e) {
      // Animation must never interrupt Add to Cart, quick shop, or sidebar drawer behavior.
    }
  };
}());
